import React, { useState, useEffect, useRef } from 'react'
import styled from '@emotion/styled'
import GoogleMapReact from 'google-map-react'
import axios from 'axios'
import { useHistory } from 'react-router-dom'

// components
import useModal from '../../components/modules/Modal/useModal'
import Modal from '../../components/modules/Modal/modal'
import Spinner from '../../components/atoms/Spinner'
import Marker from '../../components/modules/Marker'
import { InfoWindow } from './InfoWindow'

// utils
import { base_url } from '../../../utils/constants'
import { generateState } from '../../../utils/generateState'
import { fixCenterLat } from '../../../utils/fixCenterLat'

axios.defaults.withCredentials = true
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'

const APIKEY = process.env.REACT_APP_API_KEY
  ? process.env.REACT_APP_API_KEY
  : ''

const Map = () => {
  // ズーム値
  const [zoom, setZoom] = useState(15)

  // 初期表示画面
  const [currentPosition, setCurrentPosition] = useState<any>()
  const [center, setCenter] = useState(currentPosition)

  // 現在地表示/非表示
  const [showCurrentPosition, setShowCurrentPosition] = useState(true)
  const [geoLocation, setGeoLocation] = useState(false)

  // ピンの情報
  const [pinInfo, setpinInfo] = useState<any>()

  // 検索条件
  const [filtering, setFilterling] = useState({
    name: '',
    address: '',
    number: '',
    industries: generateState(15),
    services: {} as { [key: string]: boolean }, // productsテーブルから動的取得のため空で初期化
    scenario: generateState(241),
    // ignore_chain:"",
    completedFrom: '',
    completedTo: '',
    onlySameRepresentative: true,
  })

  // 獲得済み商材（api/constから取得、productsテーブル準拠）
  const [products, setProducts] = useState<Array<{ id: number; title: string }>>([])

  // クリックされた緯度経度
  const [selectedLat, setSelectedLat] = useState<any>()
  const [selectedLng, setSelectedLng] = useState<any>()
  // 緯度経度取得後API処理したデータを保持
  const [detailInfo, setDetailInfo] = useState<any>()
  // 選択したデータを保持
  const [selectedInfo, setselectedInfo] = useState('')
  // 間引き設定
  // 指定なし 全件数
  // 1       50件
  // 2       間引き（デフォ）
  const [thinning, setThinning] = useState('2')
  // モーダル表示/非表示
  const { isShowing, toggle } = useModal()

  // zoom制御のオプション
  const [scrollwheel, setscrollwheel] = useState(true)

  // オプション指定（地形・道路は表示する）
  const createMapOptions = () => {
    return {
      fullscreenControl: false,
      scrollwheel: { scrollwheel }.scrollwheel,
      gestureHandling: 'auto'
    }
  }

  const history = useHistory()

  // api/constからproductsを取得（獲得済み商材をproductsテーブルから選択可能にする）
  useEffect(() => {
    axios
      .get(`${base_url}/api/const`)
      .then(res => {
        const list = res.data?.data?.products
        if (Array.isArray(list) && list.length > 0) {
          setProducts(list.map((p: any) => ({ id: Number(p.id), title: p.title || p.name })))
        }
      })
      .catch(() => {})
  }, [])

  // setState
  // 初期表示地点
  // 注意 http接続の場合geolocationが動作しないため、現在地はlocalでは確認不可
  const success = (data: any) => {
    const currentPosition = {
      lat: data.coords.latitude,
      lng: data.coords.longitude
    }
    setCurrentPosition(currentPosition)
    setCenter(currentPosition)
    setGeoLocation(true)
  }

  const error = (data: any) => {
    const currentPosition = {
      lat: 35.680959106959,
      lng: 139.76730676352
    }
    setCurrentPosition(currentPosition)
    setCenter(currentPosition)
    setShowCurrentPosition(false)
  }

  const protocol = window.location.protocol
  // 位置情報取得
  useEffect(() => {
    if (protocol === 'http:') {
      error('')
    } else {
      navigator.geolocation.getCurrentPosition(success, error)
    }
  }, [protocol])

  // Mapのなんらかのアクションでピン情報更新
  const [lastParam, setLastParam] = useState({})

  // 選択したカテゴリー・商材のTrueのみを返す
  const newHash = (hash: any) =>
    Object.keys(hash).map((key: any) => {
      if (hash[key] === true) {
        return key
      } else {
        return null
      }
    })

  // 検索メソッド

  const [searchFlag, setSearchFlag] = useState(1)
  const [specialSearchID, setSpecialSearchID] = useState(true)
  const [searchParams, setSearchParams] = useState()

  const searchParamsRef = useRef<any>()
  const searchStore = (data: any) => {
    const paramsData: any = {
      center: data.center,
      zoom: data.zoom,
      sw: `${data.bounds.sw.lat},${data.bounds.sw.lng}`,
      ne: `${data.bounds.ne.lat},${data.bounds.ne.lng}`
    }
    searchParamsRef.current = paramsData
    setSearchParams(paramsData)
  }

  // 初期useEffect制御に使用
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      // 初回レンダー判定
      isFirstRender.current = false // もう初回レンダーじゃないよ代入
    } else {
      switch (searchFlag) {
        case 1:
          markerDrop(searchParams)
          break
        case 2:
          const data = searchParams
          specialSearch({ specialSearchID, data })
          break

        default:
          break
      }
    }
  }, [searchParams])

  const markerDrop = (data: any, filterOverride?: typeof filtering) => {
    if (!data?.center || !data?.sw || !data?.ne) return

    const url = `${base_url}/api/spots`
    const f = filterOverride ?? filtering

    const categoryHash = newHash(f.industries)
      .filter(Boolean)
      .map(Number)
    const productHash = newHash(f.services)
      .filter(Boolean)
      .map(Number)
    const scenarioHash = newHash(f.scenario)
      .filter(Boolean)
      .map(Number)
    const searchZoom = Math.max(9, Math.floor(data.zoom))
    // 絞り込み条件があるときは間引きを無効化（全表示）して見逃しを防ぐ
    const hasFilter = productHash.length > 0 || categoryHash.length > 0 || !!f.completedFrom || !!f.completedTo
    const params: any = {
      center: `${data.center.lat},${data.center.lng}`,
      zoom: searchZoom,
      sw: data.sw,
      ne: data.ne,
      keywords: f.name,
      address: f.address,
      tel: f.number,
      category_id: categoryHash,
      kakutoku_id: productHash,
      scenario_id: scenarioHash,
      // ignore_chain:"",
      pattern: hasFilter ? '' : thinning
    }
    if (f.completedFrom) params.completed_from = f.completedFrom
    if (f.completedTo) params.completed_to = f.completedTo
    if (f.onlySameRepresentative) params.only_same_representative = 1

    setZoom(data.zoom)
    setCenter(data.center)
    setLastParam(params)

    axios
      .get(url, { params: params })
      .then(res => {
        setpinInfo(res.data.data)
      })
      .catch(error => {
        console.log(error.response)
        if (error.response.status === 401) {
          console.log(error.response)
          alert('ログインしてください')
          history.push('')
        }
      })
  }

  // 検索条件追加時のみ（lastParamにboundsがない場合はスキップ）
  const markerDropAddFilter = () => {
    const lastParamArray = Object.values(lastParam)
    if (lastParamArray.length < 4 || !lastParamArray[2] || !lastParamArray[3]) {
      return // bounds(sw,ne)がない場合はAPI呼び出ししない
    }

    const url = `${base_url}/api/spots`
    const categoryHash = newHash(filtering.industries)
      .filter(Boolean)
      .map(Number)
    const productHash = newHash(filtering.services)
      .filter(Boolean)
      .map(Number)
    const scenarioHash = newHash(filtering.scenario)
      .filter(Boolean)
      .map(Number)

    const hasFilter = productHash.length > 0 || categoryHash.length > 0 || !!filtering.completedFrom || !!filtering.completedTo
    const params: any = {
      center: lastParamArray[0],
      zoom: lastParamArray[1],
      sw: lastParamArray[2],
      ne: lastParamArray[3],
      keywords: filtering.name,
      address: filtering.address,
      tel: filtering.number,
      category_id: categoryHash,
      kakutoku_id: productHash,
      scenario_id: scenarioHash,
      ignore_chain: '',
      pattern: hasFilter ? '' : thinning
    }
    if (filtering.completedFrom) params.completed_from = filtering.completedFrom
    if (filtering.completedTo) params.completed_to = filtering.completedTo
    if (filtering.onlySameRepresentative) params.only_same_representative = 1

    // console.log(params)
    axios
      .get(url, { params: params })
      .then(res => {
        setpinInfo(res.data.data)
        // setSelectedLat('')
      })
      .catch(err => {
        // console.log('移動のピン更新失敗' + err) // 失敗
      })
  }

  // 特殊検索
  const specialSearch = ({ specialSearchID, data }: any) => {
    const url = `${base_url}/api/spots/special-feature/${specialSearchID}`

    // 要変更ここの値を取得して変更
    // paramsをMOdalに渡す
    const params: any = {
      center: `${data.center.lat},${data.center.lng}`,
      sw: data.sw,
      ne: data.ne
    }
    setZoom(data.zoom)

    // console.log(params)
    axios
      .get(url, { params: params })
      .then(res => {
        setpinInfo(res.data.data)
        // setSelectedLat('')
      })
      .catch(err => {
        // console.log('移動のピン更新失敗' + err) // 失敗
      })
  }

  const fetchCustomerData = (lat: any, lng: any, scenarioHash: any, kakutokuHash?: number[]) => {
    if (!lat || !lng) {
      return
    }
    const params: any = {
      lat: lat,
      lon: lng,
      scenario_id: scenarioHash
    }
    if (kakutokuHash && kakutokuHash.length > 0) {
      params.kakutoku_id = kakutokuHash
    }
    if (filtering.completedFrom) params.completed_from = filtering.completedFrom
    if (filtering.completedTo) params.completed_to = filtering.completedTo
    if (filtering.onlySameRepresentative) params.only_same_representative = 1

    const url = `${base_url}/api/spots/show/all`
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        setDetailInfo(response.data.data)
      })
      .catch(() => {
        setDetailInfo([])
      })
  }

  // ピン選択時
  const onSelect = async (lat: number, lng: number, pin?: any) => {
    setDetailInfo('')

    const newPosition: any = {
      lat: fixCenterLat(lat, zoom),
      lng: lng
    }
    setCenter(newPosition)
    await setSelectedLng(lng)
    await setSelectedLat(lat)

    if (pin) {
      // 特別検索: 同一座標のピンで表示
      const newArray = pinInfo.filter(
        (item: any) => item.lat === lat && item.lon === lng
      )
      setDetailInfo(newArray)
    } else {
      // 通常検索: APIでふきだし用データ（顧客名・商材名・業態）取得。検索条件の商材のみ表示
      fetchCustomerData(
        lat,
        lng,
        newHash(filtering.scenario)
          .filter(Boolean)
          .map(Number),
        newHash(filtering.services).filter(Boolean).map(Number)
      )
    }
  }

  const showModal = (info: any) => {
    const productHash = newHash(filtering.services).filter(Boolean).map(Number)
    const params = productHash.length > 0 ? { kakutoku_id: productHash } : {}
    const url = `${base_url}/api/spots/${info.id}`

    axios
      .get(url, { params })
      .then(response => {
        setselectedInfo(response.data.data)
        toggle()
      })
      .catch(error => {})
  }

  const updateModal = (info: any) => {
    const productHash = newHash(filtering.services).filter(Boolean).map(Number)
    const params = productHash.length > 0 ? { kakutoku_id: productHash } : {}
    const url = `${base_url}/api/spots/${info.id}`

    axios
      .get(url, { params })
      .then(response => {
        setselectedInfo(response.data.data)
      })
      .catch(error => {
        // console.log(error.response)
      })
  }

  const showSearchModal = () => {
    setselectedInfo('')
    toggle()
  }

  const clearDetailInfo = () => {
    setscrollwheel(true)
    setDetailInfo('')
    setSelectedLat('')
  }

  // 現在地表示/非表示
  const switchShowing = (boolean: boolean) => {
    if (boolean === true) {
      setShowCurrentPosition(false)
    } else {
      setShowCurrentPosition(true)
    }
  }

  const addFiltering = (filter: any) => {
    setFilterling(filter)
  }

  // 検索ボタン押下時に即座にピン取得（useEffectの遅延・二重fetchを避ける）
  const skipNextFilteringEffect = useRef(false)
  const triggerSearch = (filter: any) => {
    addFiltering(filter)
    skipNextFilteringEffect.current = true // 直後のuseEffectをスキップ（二重fetchで結果が上書きされるのを防ぐ）
    let bounds = searchParams ?? searchParamsRef.current
    if ((!bounds?.sw || !bounds?.ne) && center) {
      const d = 0.05
      bounds = {
        center,
        zoom,
        sw: `${center.lat - d},${center.lng - d}`,
        ne: `${center.lat + d},${center.lng + d}`
      }
    }
    if (bounds?.sw && bounds?.ne) {
      markerDrop(bounds, filter)
    }
  }

  // 初期useEffect制御に使用
  const isFirstFiltering = useRef(true)
  useEffect(() => {
    // 『filtering or thinning』 が更新された場合『と』初回レンダー時に動くeffect
    if (isFirstFiltering.current) {
      isFirstFiltering.current = false
    } else if (skipNextFilteringEffect.current) {
      skipNextFilteringEffect.current = false
      return // triggerSearchで既にfetch済みのためスキップ
    } else {
      // searchParams（現在のマップ範囲）があればそれを使用
      let bounds = searchParams ?? searchParamsRef.current
      if ((!bounds?.sw || !bounds?.ne) && center) {
        const d = 0.05
        bounds = {
          center,
          zoom,
          sw: `${center.lat - d},${center.lng - d}`,
          ne: `${center.lat + d},${center.lng + d}`
        }
      }
      if (bounds?.sw && bounds?.ne) {
        markerDrop(bounds)
      } else {
        markerDropAddFilter()
      }
    }
  }, [filtering, thinning])

  //  スマホでInfoWindow内をスクロールさせる
  const isFirstRenderWindow = useRef(true)
  useEffect(() => {
    if (isFirstRenderWindow.current) {
      // 初回レンダー判定
      isFirstRenderWindow.current = false // もう初回レンダーじゃないよ代入
    } else {
      const scrollWindow = document.querySelector('.scrollWindow')
      if (!scrollWindow) {
        return
      }
      //   console.log(scrollWindow)
      // ふきだし上のマウス/タッチ操作を地図に伝えない（地図のドラッグを抑止）。
      // これがないと、テキストを選択しようとしても地図のパン操作になってしまう。
      const stopPropagation = (e: any) => e.stopPropagation()
      scrollWindow.addEventListener('touchstart', stopPropagation)
      scrollWindow.addEventListener('mousedown', stopPropagation)
      // ダブルクリックが地図のズームインにならないようにする
      scrollWindow.addEventListener('dblclick', stopPropagation)
      return () => {
        scrollWindow.removeEventListener('touchstart', stopPropagation)
        scrollWindow.removeEventListener('mousedown', stopPropagation)
        scrollWindow.removeEventListener('dblclick', stopPropagation)
        // console.log(scrollWindow)
      }
    }
  }, [detailInfo])

  // APIキー未設定のときはマップを表示せず案内を表示
  if (!APIKEY || APIKEY.trim() === '') {
    return (
      <div style={{ height: '94%', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', padding: 24, boxSizing: 'border-box' }}>
        <p style={{ fontSize: 18, color: '#333', marginBottom: 16, textAlign: 'center' }}>
          Google マップの API キーが設定されていません。
        </p>
        <p style={{ fontSize: 14, color: '#666', textAlign: 'center', maxWidth: 400 }}>
          ビルド時に <code style={{ background: '#f0f0f0', padding: '2px 6px' }}>REACT_APP_API_KEY</code> を設定するか、
          .env に追加してください。Google Cloud で「Maps JavaScript API」を有効にし、請求を有効化したキーが必要です。
        </p>
      </div>
    )
  }

  // InvalidKey / ApiProjectMapError が出る場合の案内（コンソールに表示されるエラー用）
  // → Google Cloud Console で確認: 請求の有効化、Maps JavaScript API の有効化、
  //    API キーの「アプリケーションの制限」でこのサイトのドメイン（例: localhost:20204）を HTTP リファラに追加

  return (
    <div style={{ height: '94%', width: '100%' }}>
      {currentPosition ? (
        <GoogleMapReact
          // APIKEYを設定（loading=async でパフォーマンス警告を解消）
          bootstrapURLKeys={{ key: APIKEY, loading: 'async' }}
          // センター地点
          center={center}
          // ズーム値
          zoom={zoom}
          // イベント取得

          onChange={data => searchStore(data)}
          // scrollwhellをstateで管理すると型エラーのためboolean→anyに切り替えたので、戻す？
          options={createMapOptions()}
        >
          {/* 現在地 */}
          {currentPosition && showCurrentPosition && (
            <CurrentMarker
              lat={currentPosition.lat}
              lng={currentPosition.lng}
              draggable={true}
            />
          )}
          <Modal
            isShowing={isShowing}
            hide={toggle}
            selectedInfo={selectedInfo}
            addFiltering={addFiltering}
            updateModal={updateModal}
            setThinning={setThinning}
            products={products}
            specialSearch={specialSearch}
            setSearchFlag={setSearchFlag}
            specialSearchID={specialSearchID}
            searchParams={searchParams}
            setSpecialSearchID={setSpecialSearchID}
            filtering={filtering}
            markerDrop={markerDrop}
            triggerSearch={triggerSearch}
          />
          {/* 各種ピン */}
          {pinInfo
            ? (() => {
                // 全権取得かつ200件以上取得した場合の場合アニメーションなし
                if (thinning === '' && pinInfo.length > 200) {
                  return pinInfo.map((pin: any, i: any) => {
                    return (
                      <Marker
                        key={pin.id}
                        lat={pin.lat}
                        lng={pin.lon}
                        pin={pin}
                        i={i}
                        onSelect={onSelect}
                        useAnimation={false}
                      />
                    )
                  })
                } else {
                  return pinInfo.map((pin: any, i: any) => {
                    return (
                      <Marker
                        key={pin.id}
                        lat={pin.lat}
                        lng={pin.lon}
                        pin={pin}
                        i={i}
                        onSelect={onSelect}
                        useAnimation={true}
                      />
                    )
                  })
                }
              })()
            : null}

          {/* 選択した時 */}
          {selectedLat && (
            <InfoWindowBox
              key={selectedLat}
              className="scrollWindow"
              lat={selectedLat}
              lng={selectedLng}
              onMouseEnter={() => setscrollwheel(false)}
              onMouseLeave={() => setscrollwheel(true)}
            >
              <CloseBtn type="button" onClick={() => clearDetailInfo()}>
                <img
                  src={`${window.location.origin}/images/close.svg`}
                  width="30"
                  height="30"
                  alt=""
                />
              </CloseBtn>
              {detailInfo ? (
                <InfoWindow detailInfo={detailInfo} showModal={showModal} />
              ) : (
                <InfoWindowSpinnerWrapper>
                  <Spinner />
                </InfoWindowSpinnerWrapper>
              )}
            </InfoWindowBox>
          )}
        </GoogleMapReact>
      ) : (
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      )}
      {currentPosition ? (
        <div>
          {showCurrentPosition ? (
            <GoBackBtn onClick={() => setCenter(currentPosition)}>
              <img
                src={`${window.location.origin}/images/pointer.svg`}
                width="25"
                height="25"
                alt=""
              />
            </GoBackBtn>
          ) : null}
          {geoLocation ? (
            <ShowCurrentPositionBtn
              onClick={() => switchShowing(showCurrentPosition)}
            >
              <img
                src={`${window.location.origin}/images/current_pin.svg`}
                width="25"
                height="25"
                alt=""
              />
            </ShowCurrentPositionBtn>
          ) : null}
          <ShowSearchModalBtn onClick={() => showSearchModal()}>
            <img
              src={`${window.location.origin}/images/search.svg`}
              width="25"
              height="25"
              alt=""
            />
          </ShowSearchModalBtn>
          {searchFlag === 1 && (
            <ThinningSelectBox
              value={thinning}
              // onChange={ (e:any) => setThinning(e.value)}
              onChange={(e: any) => setThinning(e.target.value)}
            >
              <option value="2">間引き</option>
              <option value="1">50件</option>
              <option value="">全表示</option>
            </ThinningSelectBox>
          )}
        </div>
      ) : null}
    </div>
  )
}

export default Map

const BoxStyle = styled.div`
  background-color: rgb(255, 255, 255);
  border: 0px;
  margin: 10px;
  padding: 0px;
  cursor: pointer;
  // user-select: none;
  border-radius: 2px;
  // box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
  outline: none;
`

const CurrentMarker = styled.div<{ lat: number; lng: number }>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #4987f2;
  position: absolute;
  transform: rotate(-45deg);
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
  margin: auto;
  border: solid 2px #fff;
  box-shadow: 0 0 0 1px #6196f2;
`

const InfoWindowBox = styled(BoxStyle)<{ lat: number; lng: number }>`
  cursor: default;
  /* Google Maps オーバーレイが継承させる user-select: none を上書きして
     ふきだし内のテキストをコピペ可能にする */
  user-select: text;
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  margin: 0;
  width: 310px;
  height: 215px;
  position: absolute;
  z-index: 99999999;
  top: -250px;
  left: 50%;
  -webkit-transform: translate(-50%);
  -ms-transform: translate(-50%);
  transform: translate(-50%);
  background-color: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  &::after {
    content: '';
    position: absolute;
    z-index: -1;
    left: 0;
    right: 0;
    bottom: -24px;
    display: block;
    width: 0;
    height: 0;
    margin: 0 auto;
    border-style: solid;
    border-width: 25px 25px 0 25px;
    border-color: #ffffff transparent transparent transparent;
  }
  @media (min-width: 450px) {
    width: 550px;
    height: 350px;
    top: -390px;
  }
`

const SpinnerWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 48%;
  transform: translateY(-50%) translateX(-48%);
  -webkit-transform: translateY(-50%) translateX(-48%);
  @media (max-width: 450px) {
    left: 40%;
    transform: translateY(-50%) translateX(-40%);
    -webkit-transform: translateY(-50%) translateX(-40%);
  }
`

const InfoWindowSpinnerWrapper = styled.div`
  position: absolute;
  top: 35%;
  left: 39%;
  transform: translateY(-35%) translateX(-39%);
  -webkit-transform: translateY(-35%) translateX(-39%);
  @media (min-width: 450px) {
    top: 40%;
    left: 44%;
    transform: translateY(-40%) translateX(-44%);
    -webkit-transform: translateY(-40%) translateX(-44%);
  }
`

const GoBackBtn = styled(BoxStyle)`
    position: absolute;
    bottom : 155px;
    right 0px;
    height: 40px;
    width: 40px;
    overflow: hidden;
    display:flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 768px) {
        bottom : 105px;
    }
`

const ShowCurrentPositionBtn = styled(BoxStyle)`
  position: absolute;
  bottom: 105px;
  right: 0;
  height: 40px;
  width: 40px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
        right: unset;
        bottom : 75px;
        left 0px;
    };
`

const ShowSearchModalBtn = styled(BoxStyle)`
  position: absolute;
  top: 90px;
  left: 0px;
  height: 40px;
  width: 40px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 15px;
  @media (max-width: 768px) {
    top: unset;
    bottom: 25px;
    left: 0px;
    margin: 10px;
  }
`
const ThinningSelectBox = styled.select`
    font-family: sans-serif;
    position: absolute;
    top : 55px;
    left 0px;
    background: none rgb(255, 255, 255);
    border: 0px;
    // margin: 10px;
    padding: 0px;
    cursor: pointer;
    // user-select: none;
    border-radius: 2px;
    height: 40px;
    width: 150px;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
    font-size: 16px;
    transform: scale(0.8);
    @media (max-width: px) {
        top : 50px;
        height: 30px;
        width: 100px;
        padding: 0 5px;
    }
`

const CloseBtn = styled.button`
  border: 0px;
  margin: 10px 10px;
  position: absolute;
  z-index: 2;
  right: 0;
  border-radius: 50%;
  padding: 0px;
  cursor: pointer;
  // user-select: none;
  height: 30px;
  width: 30px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  background: none rgb(255, 255, 255);
`
